import React from 'react';
import ContentBuilder from '../../core/ContentBuilder';
import { mergeClassNames } from '../../utils/mergeClassNames';
import styles from './LabeledList.module.scss';

interface LabeledListProps
{
	data:{
		caption?:string,
		label?:string, 
		text?:string
	}[],
}

export class LabeledList extends React.Component<LabeledListProps>
{
	render()
	{
		return (
			<ul className={mergeClassNames([this.props['className'], 'list'], styles)}>
				{
					this.props['description']?(
						<div className={styles['description']}>{this.props['description']}</div>
					):null
				}
				{
					this.props.data?.map((item, i) => {
						return (
							<li key={i} className={mergeClassNames(['item'], styles)}>
								{item['caption']?ContentBuilder.build([{tag: 'div', props: {className: ['caption', 'secondary']}, content: item['caption']}], {}, styles):null}
								<div className={styles['content']}>
									{item['label']?ContentBuilder.build({tag: 'h4', content: item['label']}, {}, styles):null}
									{item['text']?ContentBuilder.build({tag: 'div', props: {className: ['text']}, content: item['text']}, {}, styles):null}
									{item['content']?ContentBuilder.build(item['content'], {}, styles):null}
								</div>
							</li>
						)
					})
				}
			</ul>
		)
	}
}